import GroupObject from "../objects/group"
import Calc from "@/common/util/calculator"
import BaseFixmethod from "@/signomatic/app/fixmethods/base"
import ImageObject from "@/signomatic/app/objects/image"
import RectObject from "@/signomatic/app/objects/rect"

export default class RollupFixmethod extends BaseFixmethod {
  get visualPadding() {
    return { top: Calc.mmToPx(20), bottom: Calc.mmToPx(70), left: 0, right: 0 }
  }

  get count() {
    return 1
  }

  topDrawable() {
    const { width, widthPx, heightPx } = this.state
    const topHeight = Calc.mmToPx(25)
    const bottomHeight = Calc.mmToPx(85)
    const topBite = Calc.mmToPx(4.5)
    const bottomBite = Calc.mmToPx(18)
    const sideExtra = Calc.mmToPx(13)
    const small = width < 1000
    const fullWidth = widthPx + sideExtra * 2
    const items = []
    const topImg = small ? this.image("rollup_top.png") : this.image("rollup_top_1000.png")
    const bottomImg = small ? this.image("rollup_foot.png") : this.image("rollup_foot_1000.png")

    if (this.imagesLoaded && topImg && bottomImg) {
      items.push(
        new RectObject({
          fill: "transparent",
          width: fullWidth,
          height: 1,
          left: -sideExtra,
          top: 0 - bottomHeight + bottomBite,
        })
          .addClass("stand")
          .addClass("preview")
      )

      items.push(
        new ImageObject(topImg, {
          left: -sideExtra,
          top: -topHeight + topBite,
          scaleX: fullWidth / (topImg.naturalWidth || topImg.width),
          scaleY: topHeight / (topImg.naturalHeight || topImg.height),
        })
          .addClass("stand")
          .addClass("preview")
      )

      items.push(
        new ImageObject(bottomImg, {
          left: -sideExtra,
          top: heightPx - bottomBite,
          scaleX: fullWidth / (bottomImg.naturalWidth || bottomImg.width),
          scaleY: bottomHeight / (bottomImg.naturalHeight || bottomImg.height),
        })
          .addClass("stand")
          .addClass("preview")
      )
    }

    return [new GroupObject(items, { left: 0, top: 0, width: fullWidth, height: heightPx })]
  }

  protected imagePaths() {
    return [
      "/images/signomatic/fix_methods/rollup_top.png",
      "/images/signomatic/fix_methods/rollup_top_1000.png",
      "/images/signomatic/fix_methods/rollup_foot.png",
      "/images/signomatic/fix_methods/rollup_foot_1000.png",
    ]
  }
}
